import type {
  InspectionMessage,
  WireInt,
} from '../../services/roomInspectorApi';

function exactInteger(value: WireInt): bigint | undefined {
  if (typeof value === 'number')
    return Number.isSafeInteger(value) ? BigInt(value) : undefined;
  return typeof value === 'string' && /^-?\d+$/.test(value)
    ? BigInt(value)
    : undefined;
}

// The history API pages newest first. Persisted ordinals define display order;
// provider clocks and later message updates must not reorder the conversation.
export function chronologicalMessages(
  messages: InspectionMessage[],
): InspectionMessage[] {
  const rows: { message: InspectionMessage; ordinal: bigint }[] = [];
  for (const message of messages) {
    const ordinal = exactInteger(message.ordinal);
    // Legacy rows without canonical ordinals retain their supplied order.
    if (ordinal === undefined) return [...messages];
    rows.push({ message, ordinal });
  }
  return rows
    .sort((left, right) =>
      left.ordinal < right.ordinal ? -1 : left.ordinal > right.ordinal ? 1 : 0,
    )
    .map((row) => row.message);
}

export function messageTime(value: WireInt | undefined) {
  if (value === undefined) return undefined;
  const integer = exactInteger(value);
  if (integer === undefined || integer <= 0n || integer > 8640000000000000n)
    return undefined;
  const date = new Date(Number(integer));
  const parts = new Map(
    new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
      timeZoneName: 'longOffset',
    })
      .formatToParts(date)
      .map((part) => [part.type, part.value]),
  );
  return {
    iso: date.toISOString(),
    label: `${parts.get('year')}/${parts.get('month')}/${parts.get('day')} ${parts.get('hour')}:${parts.get('minute')}:${parts.get('second')} ${parts.get('timeZoneName')}`,
  };
}
